module.exports = __webpack_public_path__ + "static/media/explore_05.78becdd9.jpg";